(function () {
  const LETTER_SIZE_ORDER = ['XXS','XS','S','M','L','XL','XXL','XXXL','3XL','4XL','5XL','6XL','7XL','8XL','9XL','10XL'];
  const NUMERIC_RE = /^\d+(?:\.\d+)?$/;

  // Escala española (Pequeño / Mediano / Grande / Supergrande) y su extensión
  // nXG (eXtra Grande). Cada token se mapea a su tier inglés equivalente para
  // que el orden quede monótono y comparta "M" (Mediano = Medium = rank 3).
  // Un producto nunca mezcla ambos sistemas, así que compartir rank con
  // S / L / XL es seguro: no co-ordenan en la misma lista de tallas.
  // SG se trata como alias de XG (mismo tier XL/eXtra Grande).
  const SPANISH_SIZE_TIER = { P: 'S', M: 'M', G: 'L', SG: 'XL', XG: 'XL' };
  const SPANISH_XG_RE = /^(\d+)XG$/; // "2XG", "3XG", …

  function getSizeRank(size) {
    if (size == null) return Infinity;
    const norm = String(size).trim().toUpperCase();

    // 1) Letra inglesa directa (XXS…10XL)
    const idx = LETTER_SIZE_ORDER.indexOf(norm);
    if (idx !== -1) return idx;

    // 2) Letra española fija (P, M, G, SG, XG) → tier inglés equivalente
    const tier = SPANISH_SIZE_TIER[norm];
    if (tier) return LETTER_SIZE_ORDER.indexOf(tier);

    // 3) Española extendida nXG (2XG, 3XG…) → tier inglés nXL equivalente
    const xg = norm.match(SPANISH_XG_RE);
    if (xg) {
      const n = parseInt(xg[1], 10);
      const explicit = LETTER_SIZE_ORDER.indexOf(n + 'XL'); // "3XL"…"10XL"
      if (explicit !== -1) return explicit;
      // "2XL" no existe como token (la lista usa "XXL"); deriva del tier XL
      return LETTER_SIZE_ORDER.indexOf('XL') + (n - 1);
    }

    // 4) Numérica (entera o decimal): "40", "39.5"
    if (NUMERIC_RE.test(norm)) return 1000 + parseFloat(norm);

    // 5) Desconocida (p. ej. "UD"): al final, alfabético en compareSizes
    return Infinity;
  }

  function compareSizes(a, b) {
    const rA = getSizeRank(a);
    const rB = getSizeRank(b);
    if (rA === Infinity && rB === Infinity) {
      return String(a).localeCompare(String(b), 'es');
    }
    return rA - rB;
  }

  function sortSizes(sizes) {
    if (!Array.isArray(sizes)) return [];
    return sizes.slice().sort(compareSizes);
  }

  window.UpngSizeSorter = { LETTER_SIZE_ORDER, getSizeRank, compareSizes, sortSizes };
})();
